import dayjs from "dayjs";
import { formatAmountCompact } from "../../lib/currency";

// Categorical slots in their validated order (blue, orange, aqua, yellow,
// magenta, green, violet, red). Only used where a series has no colour of
// its own; never cycled - anything past the last slot folds into "Other".
export const CATEGORICAL = [
  "#2a78d6",
  "#eb6834",
  "#1baf7a",
  "#eda100",
  "#e87ba4",
  "#008300",
  "#4a3aa7",
  "#e34948",
];

export const INK = {
  primary: "#1f2d3d",
  secondary: "#52514e",
  muted: "#898781",
  grid: "#e1e0d9",
  axis: "#c3c2b7",
  other: "#c3c2b7",
};

// Stage / task-state colours. Won/lost/overdue use the fixed status palette
// and always ship with a text label, never colour alone.
export const STATUS = {
  good: "#0ca30c",
  serious: "#ec835a",
  critical: "#d03b3b",
  warning: "#fab219",
};

export const STAGE_META = {
  prospecting: { label: "Prospecting", color: "#86b6ef" },
  negotiation: { label: "Negotiation", color: "#2a78d6" },
  won: { label: "Won", color: STATUS.good },
  lost: { label: "Lost", color: STATUS.critical },
};

// Lead statuses carry an admin-chosen colour (hex or an antd preset name).
const PRESET_HEX = {
  blue: "#1677ff",
  green: "#52c41a",
  red: "#f5222d",
  orange: "#fa8c16",
  gold: "#faad14",
  yellow: "#fadb14",
  lime: "#a0d911",
  cyan: "#13c2c2",
  geekblue: "#2f54eb",
  purple: "#722ed1",
  magenta: "#eb2f96",
  volcano: "#fa541c",
  pink: "#eb2f96",
  default: "#8c8c8c",
};

export const resolveStatusColor = (color, index = 0) => {
  const c = String(color || "").trim().toLowerCase();
  if (/^(#|rgb|hsl)/.test(c)) return color;
  if (PRESET_HEX[c]) return PRESET_HEX[c];
  return CATEGORICAL[index % CATEGORICAL.length];
};

export const compactAmount = (value, country) =>
  formatAmountCompact({ value, country, decimals: 1 });

export const fullAmount = (value) => Number(value || 0).toLocaleString();

// Percent change against the previous period. `null` = nothing to compare to.
export const pctChange = (current, previous) => {
  const cur = Number(current || 0);
  const prev = Number(previous || 0);
  if (prev === 0) return cur > 0 ? null : 0;
  return ((cur - prev) / prev) * 100;
};

export const PERIOD_OPTIONS = [
  { label: "7 days", value: "7d" },
  { label: "30 days", value: "30d" },
  { label: "90 days", value: "90d" },
  { label: "This month", value: "month" },
  { label: "Custom", value: "custom" },
];

export const periodLabel = (period) => {
  if (!period) return "";
  if (period.key === "month") return "this month";
  if (period.key === "custom") {
    return `from ${dayjs(period.start).format("DD MMM YYYY")} to ${dayjs(period.end).format("DD MMM YYYY")}`;
  }
  return `last ${period.days} days`;
};

export const previousLabel = (period) =>
  period?.key === "month" || period?.key === "custom"
    ? "previous period"
    : `previous ${period?.days || ""} days`.trim();
